import { getShiftParticipantHistoryStorage } from './getShiftParticipantHistoryStorage';
export function createShiftParticipantHistory(context, data, actionParams) {
    const storage = getShiftParticipantHistoryStorage(context);
    storage.post({
        action: 'create',
        data: data,
        actionParams: actionParams,
    });
}
